export { useBnplIntentMutation } from './useBnplIntentMutation';
